export default __webpack_public_path__ + "static/HouseOfMaltLogo-442b70b22a0d5d62c86a3ec0d2fedc66.svg";